/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

export const IMPORT_WORKSHEET_INIT = 'IMPORT_WORKSHEET_INIT';
export const IMPORT_WORKSHEET_INIT_RESOLVE = 'IMPORT_WORKSHEET_INIT_RESOLVE';
export const IMPORT_WORKSHEET_UPDATE_SEARCH = 'IMPORT_WORKSHEET_UPDATE_SEARCH';
export const IMPORT_WORKSHEET_UPDATE_SEARCH_RESOLVE = 'IMPORT_WORKSHEET_UPDATE_SEARCH_RESOLVE';
export const IMPORT_WORKSHEET_UPDATE_SEARCH_REJECT = 'IMPORT_WORKSHEET_UPDATE_SEARCH_REJECT';
export const IMPORT_WORKSHEET_CLEANUP = 'IMPORT_WORKSHEET_CLEANUP';

//Initialise component state
export const initImportedWorksheet = (id, params) => ({ type: IMPORT_WORKSHEET_INIT, id, params });
export const initImportedWorksheetResolve = (id, selectedTest) => ({
  type: IMPORT_WORKSHEET_INIT_RESOLVE,
  id,
  selectedTest,
});

//Search for a test worksheet - whenever search criteria are updated, see if we can find a match
export const updateImportedWorksheetSearch = (id, params) => ({ type: IMPORT_WORKSHEET_UPDATE_SEARCH, id, params });
export const updateImportedWorksheetSearchResolve = (id, selectedTest) => ({
  type: IMPORT_WORKSHEET_UPDATE_SEARCH_RESOLVE,
  selectedTest,
  id,
});
export const updateImportedWorksheetSearchReject = (id) => ({ type: IMPORT_WORKSHEET_UPDATE_SEARCH_REJECT, id });

//Clear component state
export const cleanupImportedWorksheet = (id) => ({ type: IMPORT_WORKSHEET_CLEANUP, id });
